import React, { useEffect, useContext } from "react";
import { ConfigContext } from "../../Context/ConfigContext";
import { NavLink } from "react-router-dom";
import AccountSiderBar from "./AccountSideBar";
import { useTranslation } from 'react-i18next';

const Account = () => {

    const { currency } = useContext(ConfigContext)

    const { t } = useTranslation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const LogoutHandle = () => {
        localStorage.setItem('token', '');
        localStorage.setItem('business_user_id', '');
        localStorage.setItem('business_id', '');
        localStorage.setItem('user_name', '');
        localStorage.setItem('business_name', '');
        localStorage.setItem('business_contact_number', '');

        localStorage.removeItem("marqueeRows");
        localStorage.removeItem("business_delivery_days");
        localStorage.removeItem("popup_seen");
        localStorage.removeItem("currency");

        window.location = '/Login';
    }

    const dir = localStorage.getItem('dir');

    return (
        <main style={{ marginTop: "-10px" }}>
            <div className="page-header">
                <div className="container d-flex flex-column align-items-center">
                    <nav aria-label="breadcrumb" className="breadcrumb-nav">
                        <div className="container">
                            <ol className="breadcrumb" dir={dir}>
                                <li className="breadcrumb-item">
                                    <NavLink to={'/'}>{t("home")}</NavLink>
                                </li>
                                <li className="breadcrumb-item">
                                    <a href={() => { }} style={{ cursor: "pointer" }}>{t("my_account")}</a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    {t("my_account")}
                                </li>
                            </ol>
                        </div>
                    </nav>
                    <h1>{t("my_account")}</h1>
                </div>
            </div>
            <div className="container account-container custom-account-container" dir={dir}>
                <div className="row justify-content-center">

                    <AccountSiderBar />
                    <div className="col-lg-9 order-lg-last order-1 tab-content">
                        <div className="tab-pane fade show active" id="address" role="tabpanel">
                            <div className="dashboard-content">
                                <p>
                                    {t("hello", { value: localStorage.getItem("first_name") })}
                                </p>

                                <div className="mb-4" />


                                <div className="row row-lg">


                                    <div className="col-6 col-md-4">
                                        <NavLink className="nav-link" to={`/MyAccount/Orders`} >
                                            <div className="feature-box text-center pb-4">
                                                <a href="#order" className="link-to-tab">
                                                    <i className="sicon-social-dropbox" />
                                                </a>
                                                <div className="feature-box-content">
                                                    <h3>{t("orders")}</h3>
                                                </div>
                                            </div>
                                        </NavLink>
                                    </div>

                                    {
                                        currency.toLowerCase() !== 'usd' &&
                                        <>
                                            <div className="col-6 col-md-4">
                                                <NavLink className="nav-link" to={`/MyAccount/MyCreditNote`} >
                                                    <div className="feature-box text-center pb-4">
                                                        <a href="#order" className="link-to-tab">
                                                            <i className="sicon-credit-card" />
                                                        </a>
                                                        <div className="feature-box-content">
                                                            <h3>Credit Note</h3>
                                                        </div>
                                                    </div>
                                                </NavLink>
                                            </div>


                                            <div className="col-6 col-md-4">
                                                <NavLink className="nav-link" to={`/MyAccount/CreditStatement`} >
                                                    <div className="feature-box text-center pb-4">
                                                        <a href="#download" className="link-to-tab">
                                                            <i className="sicon-list" />
                                                        </a>
                                                        <div className=" feature-box-content">
                                                            <h3>Credit Statement</h3>
                                                        </div>
                                                    </div>
                                                </NavLink>
                                            </div>
                                            
                                            <div className="col-6 col-md-4">
                                                <NavLink className="nav-link" to={`/MyAccount/RedeemPoints`} >
                                                    <div className="feature-box text-center pb-4">
                                                        <a href="#download" className="link-to-tab">
                                                            <i className="sicon-star" />
                                                        </a>
                                                        <div className=" feature-box-content">
                                                            <h3>Rewards</h3>
                                                        </div>
                                                    </div>
                                                </NavLink>
                                            </div>
                                        </>

                                    }


                                    <div className="col-6 col-md-4">
                                        <NavLink className="nav-link" to={`/MyAccount/ManageAddress`} >
                                            <div className="feature-box text-center pb-4">
                                                <a href="#address" className="link-to-tab">
                                                    <i className="sicon-location-pin" />
                                                </a>
                                                <div className="feature-box-content">
                                                    <h3>{t("addresses")}</h3>
                                                </div>
                                            </div>
                                        </NavLink>
                                    </div>

                                    <div className="col-6 col-md-4">
                                        <NavLink className="nav-link" to={`/MyAccount/AccountDetails`} >
                                            <div className="feature-box text-center pb-4">
                                                <a href="#edit" className="link-to-tab">
                                                    <i className="icon-user-2" />
                                                </a>
                                                <div className="feature-box-content p-0">
                                                    <h3>{t("account_details")}</h3>
                                                </div>
                                            </div>
                                        </NavLink>
                                    </div>

                                    {
                                        currency.toLowerCase() !== "usd" &&
                                        <div className="col-6 col-md-4">
                                            <NavLink className="nav-link" to={`/MyAccount/RequestCreditList`} >
                                                <div className="feature-box text-center pb-4">
                                                    <a href="#edit" className="link-to-tab">
                                                        <i className="fas fa-credit-card" />
                                                    </a>
                                                    <div className="feature-box-content p-0">
                                                        <h3>{"Request Credit List"}</h3>
                                                    </div>
                                                </div>
                                            </NavLink>
                                        </div>
                                    }

                                    <div className="col-6 col-md-4">
                                        <div className="feature-box text-center pb-4" onClick={LogoutHandle} >
                                            <i className="sicon-logout" />
                                            <div className="feature-box-content p-0">
                                                <h3>{t("logout")}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default Account;
